import React, { createContext, ReactNode, useEffect, useState } from 'react';
import * as Yup from 'yup';

import { Form } from '@components/Form';

interface IWizardContext {
  isInitialized: boolean;
  stepsCount: number;
  stepIndex: number;
  setStepIndex: (stepIndex: number) => void;
  setValidationSchemas: (validationSchemas: ReturnType<typeof Yup.object>[]) => void;
}

export const WizardContext = createContext<IWizardContext>(null);

interface IProps<T> {
  initialValues: T;
  children: ReactNode | ReactNode[];
  onComplete: (values: T) => any | Promise<any>;
}

function Wizard<T>({ initialValues, children, onComplete }: IProps<T>) {
  const [stepIndex, setStepIndex] = useState(0);
  const [isInitialized, setIsInitialized] = useState(false);
  const [validationSchemas, setValidationSchemas] = useState<ReturnType<typeof Yup.object>[]>([]);

  useEffect(() => {
    if (validationSchemas.length > 0) {
      setIsInitialized(true);
    }
  }, [validationSchemas]);

  return (
    <WizardContext.Provider
      value={{
        isInitialized,
        stepIndex,
        setStepIndex,
        setValidationSchemas,
        stepsCount: validationSchemas.length,
      }}>
      <Form
        initialValues={initialValues}
        validationSchema={validationSchemas[stepIndex]}
        onSubmit={onComplete}>
        {children}
      </Form>
    </WizardContext.Provider>
  );
}

export default Wizard;
